var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 50,
  height: 50
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#7F2A90",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.786 22.049v-1.476a2.95 2.95 0 0 0-2.951-2.952H6.553a2.95 2.95 0 0 0-2.951 2.952v8.854a2.95 2.95 0 0 0 2.951 2.951h13.282a2.95 2.95 0 0 0 2.951-2.951v-1.476M25 5.814v5.904M25 38.282v5.904M33.855 9.123l-2.214 4.374M18.359 36.503l-2.213 4.374M16.146 9.123l2.213 4.374M31.641 36.503l2.214 4.374M27.214 27.952v1.476a2.95 2.95 0 0 0 2.951 2.951h13.282a2.95 2.95 0 0 0 2.951-2.951v-8.854a2.95 2.95 0 0 0-2.951-2.952H30.165a2.95 2.95 0 0 0-2.951 2.952v1.476"
}))));
export default SvgLink;